import script from "./DemoConfigEditLogbook.vue?vue&type=script&setup=true&lang=js"
export * from "./DemoConfigEditLogbook.vue?vue&type=script&setup=true&lang=js"

import "./DemoConfigEditLogbook.vue?vue&type=style&index=0&id=07e30a54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e30a54"]])

export default __exports__